import { Box, Modal, Text, Textarea } from "@mantine/core";
import { useEffect, useState } from "react";
import { closeBtnSx, ghostBtnSx, modalFooterSx, modalHeaderSx, primaryBtnSx } from "./styles";

// Small free-text prompt shown when a DSP picks an activity from a section
// that needs a specific response (e.g. Health Monitoring readings).
const FieldResponseModal = ({ opened, activityName, onCancel, onSubmit }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (opened) setValue("");
  }, [opened]);

  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      size={440}
      radius={12}
      zIndex={1500}
      overlayProps={{ blur: 3 }}
      padding={0}
      withCloseButton={false}
      styles={{ body: { padding: 0 } }}
    >
      <Box sx={modalHeaderSx}>
        <Text fz={16} fw={600} ff="Inter">{activityName}</Text>
        <Box component="button" onClick={onCancel} sx={closeBtnSx}>✕</Box>
      </Box>

      <Box sx={{ padding: "18px 22px" }}>
        <Text fz={16} fw={600} ff="Inter" mb={14}>Add a specific response</Text>
        <Textarea
          autosize
          minRows={4}
          placeholder="Type a response for this activity"
          value={value}
          onChange={(e) => setValue(e.currentTarget.value)}
          styles={{
            input: {
              borderRadius: 10, fontFamily: "Inter", fontSize: 14, lineHeight: 1.5,
              borderColor: "var(--app-border)", padding: "10px 12px",
              background: "var(--app-surface)", color: "var(--app-text)",
            },
          }}
        />
      </Box>

      <Box sx={modalFooterSx}>
        <Box component="button" onClick={() => onSubmit("")} sx={ghostBtnSx}>
          Cancel
        </Box>
        <Box component="button" onClick={() => onSubmit(value.trim())} sx={primaryBtnSx(false)}>
          Add
        </Box>
      </Box>
    </Modal>
  );
};

export default FieldResponseModal;
